<template>
  <div class="contents">
    <div class="wrap">

      <!-- 검색 영역 -->
      <section>
        <h2 class="page_title --view">세금계산서 발행 현황</h2>
        <article>
          <ul class="search_filter">
            <!-- 1행: 텍스트 검색 -->
            <li>
              <p>한의원명</p>
              <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.clinicNm" @keyup.enter="fn_search">
            </li>
            <li>
              <p>사업자번호</p>
              <input type="text" placeholder="입력하세요" class="form_control" style="max-width:180px;" v-model="searchInfo.bizNo" @keyup.enter="fn_search">
            </li>
            <li>
              <p>세금계산서번호</p>
              <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.invoiceNo" @keyup.enter="fn_search">
            </li>
            <!-- 행 구분 -->
            <li class="row_break"></li>
            <!-- 2행: 기간·상태·버튼 -->
            <li>
              <p>조회기간</p>
              <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate" :format="'YYYY-MM-DD'" />
              <span>~</span>
              <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate" :format="'YYYY-MM-DD'" />
            </li>
            <li>
              <p>발행상태</p>
              <div class="form_radio" v-for="opt in statusOptions" :key="opt.value">
                <input type="radio" :id="'inv_status_' + opt.value" name="inv_status" :value="opt.value" v-model="searchInfo.invoiceStatus">
                <label :for="'inv_status_' + opt.value">{{ opt.label }}</label>
              </div>
            </li>
            <li>
              <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              <button class="btn btn_md btn_gray ml8" @click="fn_reset_search">초기화</button>
            </li>
          </ul>
        </article>
      </section>

      <section class="view">

        <!-- 상단 요약 카드 -->
        <div class="summary_area">
          <div class="summary_card" v-for="card in summaryCards" :key="card.key">
            <p class="card_label">{{ card.label }}</p>
            <strong class="card_value" :class="card.colorClass">
              {{ fn_format_card(card) }}
            </strong>
          </div>
        </div>

        <!-- 세금계산서 목록 -->
        <div class="table_list">
          <table class="list">
            <thead>
              <tr>
                <th>세금계산서번호</th>
                <th>한의원명</th>
                <th>사업자번호</th>
                <th class="ar">발행금액</th>
                <th>발행일시</th>
                <th class="ac">상세</th>
                <th class="ac">취소요청</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="invoiceList.length === 0">
                <td colspan="7" class="ac"><span>조회된 데이터가 없습니다.</span></td>
              </tr>
              <tr v-for="(item, index) in invoiceList" :key="index">
                <td><span :class="item.is_cancel ? 'color_red' : 'color_blue'">{{ item.invoice_no }}</span></td>
                <td><span :class="item.is_cancel ? 'color_red' : 'color_blue'">{{ item.clinic_nm }}</span></td>
                <td><span :class="item.is_cancel ? 'color_red' : 'color_blue'">{{ formatBizNumber(item.clinic_business_num) }}</span></td>
                <td class="ar">
                  <span :class="item.is_cancel ? 'color_red' : 'color_blue'">
                    {{ item.is_cancel ? '-' : '+' }}{{ fn_comma_won(item.issue_amt) }}원
                  </span>
                </td>
                <td><span :class="item.is_cancel ? 'color_red' : 'color_blue'">{{ item.issue_dt }}</span></td>
                <td class="ac">
                  <button class="btn btn_sm btn_outline" @click="fn_open_detail(item)">상세보기</button>
                </td>
                <td class="ac">
                  <button class="btn btn_sm btn_cancel" :disabled="item.is_cancel" @click="fn_cancel(item)">발행취소</button>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_movePage" v-show="pagingShow" />
        </div>
      </section>
    </div>

    <TaxInvoiceDetailModal :detailData="detailData" />
  </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from '@/mixin/commonUtil'
  import alertModalUtill from '@/mixin/alertModalUtill'
  import Pagination from '@/components/AdminPagination.vue'
  import Datepicker from '@/components/Datepicker.vue'
  import TaxInvoiceDetailModal from '@/modal/admin/taxInvoiceDetailModal.vue'

  export default {
    name: 'TaxInvoiceStatus',
    components: { Pagination, Datepicker, TaxInvoiceDetailModal },
    mixins: [commonUtil, alertModalUtill],
    data() {
      return {
        searchInfo: {
          startDate: '',
          endDate: '',
          clinicNm: '',
          bizNo: '',
          invoiceNo: '',
          invoiceStatus: '',
          pageInfo: { page: 1, pageSize: 10, totPage: 0 }
        },
        statusOptions: [
          { value: '',       label: '전체' },
          { value: 'NORMAL', label: '정상' },
          { value: 'CANCEL', label: '취소(마이너스)' }
        ],
        pagingShow: false,
        invoiceList: [],
        summaryInfo: {
          normal_cnt: 0, cancel_cnt: 0,
          normal_amt: 0, cancel_amt: 0, total_amt: 0
        },
        summaryCards: [
          { key: 'normal_cnt', label: '정상 발행 건수',        unit: '건', isAmt: false, colorClass: 'text_blue' },
          { key: 'cancel_cnt', label: '마이너스 발행 건수',    unit: '건', isAmt: false, colorClass: 'text_red' },
          { key: 'normal_amt', label: '정상 발행 금액',        unit: '원', isAmt: true,  colorClass: 'text_blue' },
          { key: 'cancel_amt', label: '마이너스 발행 금액',    unit: '원', isAmt: true,  colorClass: 'text_red' },
          { key: 'total_amt',  label: '발행완료 합계',         unit: '원', isAmt: true,  colorClass: 'text_blue' }
        ],
        detailData: null
      }
    },
    created() {
      const stored = this.$store.getters['commonStore/getSearchInfo']
      if (stored && Object.keys(stored).length > 0) {
        this.searchInfo = stored
      }
    },
    mounted() {
      const today = new Date()
      const y = today.getFullYear()
      const m = (today.getMonth() + 1).toString().padStart(2, '0')
      const d = today.getDate().toString().padStart(2, '0')
      this.searchInfo.startDate = `${y}-${m}-01`
      this.searchInfo.endDate   = `${y}-${m}-${d}`
      this.fn_search()
    },
    methods: {
      fn_search() {
        this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo)
        const payload = { ...this.searchInfo, bizNo: this.searchInfo.bizNo.replace(/-/g, '') }
        axios.post('/api/admin/settlement/getTaxInvoiceList', payload)
          .then(res => {
            this.invoiceList = res.data.invoiceList
            Object.assign(this.summaryInfo, res.data.summaryInfo)
            this.searchInfo.pageInfo.totPage = res.data.totCnt
            this.pagingShow = res.data.totCnt > this.searchInfo.pageInfo.pageSize
          })
          .catch(() => {
            // API 미연동 시 더미 데이터
            this.invoiceList = this.fn_dummy_list()
            const normal = this.invoiceList.filter(i => !i.is_cancel)
            const cancel = this.invoiceList.filter(i =>  i.is_cancel)
            const normalAmt = normal.reduce((s, i) => s + i.issue_amt, 0)
            const cancelAmt = cancel.reduce((s, i) => s + i.issue_amt, 0)
            Object.assign(this.summaryInfo, {
              normal_cnt: normal.length, cancel_cnt: cancel.length,
              normal_amt: normalAmt,     cancel_amt: cancelAmt,
              total_amt:  normalAmt - cancelAmt
            })
            this.pagingShow = false
          })
      },
      fn_reset_search() {
        const today = new Date()
        const y = today.getFullYear()
        const m = (today.getMonth() + 1).toString().padStart(2, '0')
        const d = today.getDate().toString().padStart(2, '0')
        this.searchInfo = {
          startDate: `${y}-${m}-01`,
          endDate:   `${y}-${m}-${d}`,
          clinicNm: '', bizNo: '', invoiceNo: '', invoiceStatus: '',
          pageInfo: { page: 1, pageSize: 10, totPage: 0 }
        }
        this.fn_search()
      },
      fn_movePage(page) {
        this.searchInfo.pageInfo.page = page
        this.fn_search()
      },
      fn_open_detail(item) {
        this.detailData = { ...item }
        this.$nextTick(() => {
          this.$bvModal.show('taxInvoiceDetailModal')
        })
      },
      fn_cancel(item) {
        if (item.is_cancel) return
        this.fn_open_alert({
          title: '세금계산서 취소',
          msg: `[${item.invoice_no}] 세금계산서를 취소하시겠습니까?`,
          btn: [
            { name: '취소', func: () => this.fn_open_alert_close() },
            {
              name: '확인',
              func: () => {
                this.fn_open_alert_close()
                axios.post('/api/admin/settlement/cancelTaxInvoice', { invoice_no: item.invoice_no })
                  .then(() => this.fn_search())
                  .catch(err => console.log(err))
              }
            }
          ]
        })
      },
      fn_dummy_list() {
        const clinics = [
          { clinic_nm: '행복한의원',   clinic_business_num: '1234567890' },
          { clinic_nm: '건강한의원',   clinic_business_num: '9876543210' },
          { clinic_nm: '미래한의원',   clinic_business_num: '1122334455' },
          { clinic_nm: '자연한의원',   clinic_business_num: '5544332211' },
          { clinic_nm: '하늘한의원',   clinic_business_num: '9988776655' }
        ]
        const amts = [325000, 480000, 215000, 560000, 390000, 145000, 720000]
        const pad  = n => String(n).padStart(2, '0')
        return Array.from({ length: 7 }, (_, i) => {
          const c = clinics[i % clinics.length]
          const isCancel = (i === 2 || i === 5)
          return {
            invoice_no:           `INV202606${pad(i + 1)}`,
            clinic_nm:            c.clinic_nm,
            clinic_business_num:  c.clinic_business_num,
            issue_amt:            amts[i % amts.length],
            issue_dt:             `2026-06-${pad(i + 1)} 10:${pad(i * 7 % 60)}`,
            is_cancel:            isCancel
          }
        })
      },
      fn_format_card(card) {
        const val = this.summaryInfo[card.key] || 0
        return card.isAmt
          ? `${this.fn_comma_won(val)}${card.unit}`
          : `${val.toLocaleString('ko-KR')}${card.unit}`
      }
    }
  }
</script>

<style scoped>
  /* 검색 행 강제 줄바꿈 */
  ::v-deep .search_filter li.row_break {
    flex-basis: 100%;
    min-width: 0;
    height: 0;
    margin: 0;
    padding: 0;
  }

  .summary_area {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  .summary_card {
    flex: 1;
    min-width: 150px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 18px 20px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  }
  .card_label { font-size: 1.3rem; color: #888; margin-bottom: 8px; }
  .card_value { font-size: 1.7rem; font-weight: 700; color: #262939; }
  .text_blue { color: #2b6cb0; }
  .text_red  { color: #c53030; }

  .color_blue { color: #2b6cb0; font-weight: 600; }
  .color_red  { color: #c53030; font-weight: 600; }
  .ar { text-align: right; }
  .ac { text-align: center; }
  .ml8 { margin-left: 8px; }

  .btn_cancel {
    border: 1px solid #c53030;
    color: #c53030;
    background: #fff;
  }
  .btn_cancel:hover:not(:disabled) {
    background: #fff5f5;
  }
  .btn_cancel:disabled {
    border-color: #e2e8f0;
    color: #a0aec0;
    cursor: not-allowed;
  }
</style>